module.exports = __webpack_public_path__ + "static/media/dev.badc2d3e.png";